import { gsap } from "gsap";
import { getKeyboardFocusableElements } from '../utils';

export default class ExhibitionCollapse {
    constructor(el) {
		this.el = el;
		this.content = el.querySelector('[data-collapse-content]');
        this.inner = el.querySelector('[data-collapse-inner]');
        this.image = el.querySelector('[data-collapse-image]');
		this.toggleButton = el.querySelector('[data-collapse-toggle]');
        this.title = this.toggleButton.getAttribute('data-title');

		this.toggleButton.addEventListener('click', (e) => {
			this.toggle(false);
		});


		if (!this.isOpen) {
            this.close(true);
		} else {
			this.open(true);
		}
	}


	get isOpen() {
		return this.el.classList.contains('is-open');
	}

    toggle(instant) {
        if(this.isOpen) {
            this.close(instant);
        } else {
            this.open(instant);
        }
    }

	open(instantly = false, event) {
        const contentHeight = this.content.scrollHeight;
        const imageHeight = this.image.scrollHeight-this.toggleButton.scrollHeight;

        this.el.classList.add('is-open');

        gsap.to(this.content, {
            height: Math.max(contentHeight, imageHeight),
            duration: instantly ? 0 : 0.3,
            ease: 'sine.inOut',
            onComplete: () => {
                gsap.to([this.inner, this.image], {
                    autoAlpha: 1,
                    duration: instantly ? 0 : 0.3,
                    ease: 'sine.inOut',
                });
            }
        });

		this.toggleButton.setAttribute('aria-expanded', true);
        this.toggleButton.setAttribute('aria-label', 'Collapse: '+this.title);
        this.toggleButton.setAttribute('data-show-cursor', 'less');
        document.dispatchEvent(new CustomEvent('hide-cursors'));
		getKeyboardFocusableElements(this.content).forEach((element) => element.removeAttribute('tabindex'));
	}


	close(instantly = false) {
		this.el.classList.remove('is-open');

        gsap.to([this.inner, this.image], {
            autoAlpha: 0,
            duration: instantly? 0 : 0.3,
            ease: 'sine.inOut',
            onComplete: () => {
                gsap.to(this.content, {
                    height: 0,
                    duration: instantly? 0 : 0.3,
                    ease: 'sine.inOut',
                });
            }
        });

		this.toggleButton.setAttribute('aria-expanded', false);
        this.toggleButton.setAttribute('aria-label', 'Expand: '+this.title);
        this.toggleButton.setAttribute('data-show-cursor', 'more');
        document.dispatchEvent(new CustomEvent('hide-cursors'));
		getKeyboardFocusableElements(this.content).forEach((element) => (element.tabIndex = -1));
	}
}